import {
  COOKIE_EXPIRY_DAYS,
  RESULTS_PER_PAGE_COOKIE_NAME,
} from '@lib/constants/cookies';
import Cookie from 'js-cookie';
import { isPageSizeOption } from './pageSize';

export const RESULTS_PER_PAGE_KEY = RESULTS_PER_PAGE_COOKIE_NAME;

export function getResultsPerPageFromLocalStorage(): number | undefined {
  try {
    const value = localStorage?.getItem(RESULTS_PER_PAGE_KEY);
    return value ? parseInt(value, 10) : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Mirror the preference into a cookie so the SSR search page can run its first
 * Coveo query at the saved page size instead of correcting it with a second
 * query after hydration. Only dropdown options persist: a custom URL page size
 * is a one-off override, never a preference.
 */
export function syncResultsPerPageCookie(numberOfResults: number): void {
  if (!isPageSizeOption(numberOfResults)) return;
  Cookie.set(RESULTS_PER_PAGE_COOKIE_NAME, numberOfResults.toString(), {
    expires: COOKIE_EXPIRY_DAYS,
  });
}

/**
 * Persist the preference to both stores: localStorage stays the client-side
 * source of truth (read by the CSR surfaces and the SSR migration effect), the
 * cookie is the server-readable copy the SSR search page seeds its first query
 * from.
 */
export function saveResultsPerPagePreference(numberOfResults: number): void {
  if (!isPageSizeOption(numberOfResults)) return;
  try {
    localStorage?.setItem(RESULTS_PER_PAGE_KEY, numberOfResults.toString());
    syncResultsPerPageCookie(numberOfResults);
  } catch {
    // localStorage may be unavailable — skip the cookie too: a cookie ahead
    // of localStorage would make the SSR migration effect revert the newest
    // choice to the stale localStorage value on every load.
  }
}
